export const FETCH_STR_CASE_REPORT_BY_CASE_ID =
  'FETCH_STR_CASE_REPORT_BY_CASE_ID';
export const FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS =
  'FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS';
export const FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL =
  'FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL';

export const UPDATE_STR_CASE_REPORT_BY_CASE_ID =
  'UPDATE_STR_CASE_REPORT_BY_CASE_ID';
export const UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS =
  'UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS';
export const UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL =
  'UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL';

export const CREATE_STR_CASE_REPORT_BY_CASE_ID =
  'CREATE_STR_CASE_REPORT_BY_CASE_ID';
export const CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS =
  'CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS';
export const CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL =
  'CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL';
export const CLOSE_SUCCESS_MODAL = 'CLOSE_SUCCESS_MODAL';
export const CLOSE_ERROR_MODAL = 'CLOSE_ERROR_MODAL';

export const fetchSTRCaseReportByCaseId = (payload) => ({
  type: FETCH_STR_CASE_REPORT_BY_CASE_ID,
  payload: payload
});

export const fetchSTRCaseReportByCaseIdSuccess = (reportDetails) => ({
  type: FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  payload: reportDetails
});

export const fetchSTRCaseReportByCaseIdFail = (message) => ({
  type: FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  payload: { message }
});

export const updateSTRCaseReportByCaseId = (reportUpatedFields) => ({
  type: UPDATE_STR_CASE_REPORT_BY_CASE_ID,
  payload: { reportUpatedFields }
});

export const updateSTRCaseReportByCaseIdSuccess = () => ({
  type: UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS
});

export const updateSTRCaseReportByCaseIdFail = (message) => ({
  type: UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  payload: { message }
});

export const createSTRCaseReportByCaseId = ({ caseId, alertIds }) => ({
  type: CREATE_STR_CASE_REPORT_BY_CASE_ID,
  payload: { caseId, alertIds }
});

export const createSTRCaseReportByCaseIdSuccess = (reportDetails) => ({
  type: CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  payload: reportDetails
});

export const createSTRCaseReportByCaseIdFail = (message) => ({
  type: CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  payload: { message }
});

export const closeSuccessModal = () => ({
  type: CLOSE_SUCCESS_MODAL
});

export const closeErrorModal = () => ({
  type: CLOSE_ERROR_MODAL
});
